import Select from 'react-select';

function CustomSelectPicker({
  label,
  options,
  value,
  onChange,
  menuPlacement = 'auto',
  isDisabled,
  placeholder = 'Select...',
  isError,
  errorMessage,
  allowReset,
  resetLabel = 'Select option',
  ...props
}) {
  const handleChange = selectedOption => {
    if (selectedOption && selectedOption.value === 'reset') {
      onChange(null);
    } else {
      onChange(selectedOption);
    }
  };

  const optionsWithReset = allowReset ? [{ value: 'reset', label: resetLabel }, ...options] : options;

  return (
    <div className="custom-select-picker">
      {label && <label>{label}</label>}
      <Select
        value={value || ''}
        options={optionsWithReset}
        maxMenuHeight={200}
        menuPlacement={menuPlacement}
        styles={{ menuPortal: base => ({ ...base, zIndex: 99999999 }) }}
        menuPortalTarget={document.body}
        isDisabled={isDisabled}
        onChange={handleChange}
        placeholder={placeholder}
        classNamePrefix={`${isError ? 'error-select-field' : ''} select-field`}
        {...props}
      />
      {isError && errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

export default CustomSelectPicker;
